import React from 'react';
import {remCss, scssVariables as variables} from 'src/helpers';

const JourneyIcon = React.memo(
    ({pathFill = variables['colors-mc-text-primary'], width = 38}) => (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={remCss(width)}
            height={remCss(width)}
            viewBox="0 0 38 38"
        >
          <path opacity="0.3"
                d="M19.942 32.244H18.3824C17.7687 30.1511 15.8418 28.6167 13.5477 28.6167C11.2537 28.6167 9.32682 30.1461 8.71306 32.244H7.15348C6.87678 32.244 6.65039 32.4704 6.65039 32.7471C6.65039 33.0238 6.87678 33.2501 7.15348 33.2501H19.937C20.2137 33.2501 20.4401 33.0238 20.4401 32.7471C20.4401 32.4704 20.2187 32.244 19.942 32.244Z"
                fill={pathFill}/>
          <path
              d="M30.2556 6.12855C25.3606 2.85344 20.4605 9.99227 15.5654 7.24038V17.6241C20.3397 20.3006 25.1141 13.5894 29.8833 16.2809C30.311 16.5224 30.8392 16.2306 30.8392 15.7426V7.24038C30.8342 6.79766 30.6229 6.37506 30.2556 6.12855Z"
              fill={pathFill}/>
          <path
              d="M14.5543 27.6959V5.76121C14.5543 5.48451 14.4437 5.23297 14.2575 5.04682C14.0764 4.86571 13.8249 4.75 13.5482 4.75C12.9948 4.75 12.542 5.20278 12.542 5.75618V27.6909C12.869 27.6355 13.2061 27.6053 13.5482 27.6053C13.8903 27.6104 14.2273 27.6406 14.5543 27.6959Z"
              fill={pathFill}/>
        </svg>
    ),
);
JourneyIcon.displayName = 'JourneyIcon';

export default JourneyIcon;
